import { gql } from 'urql';

const QueryMyAccountsBelieveCardAccount = gql`
  query MyAccountsChargeCardAccount {
    myAccounts {
      id
      chargeCard {
        id
        type
        product
        status
        action {
          type
          title
          message
          location
          cardCta
        }
      }
    }
  }
`;

export default QueryMyAccountsBelieveCardAccount;
